// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from "@tanstack/react-query";
import { HttpClientInstance, useHttpClient } from "@toggl/sync/http";
import {} from "../types";
import { createQueryOptions } from "../utils/queries";
import {
  getJobopeningCareersAvailableQueryKey,
  getJobopeningCareersQueryKey,
  getJobopeningDescriptionQueryKey,
  getPublicJobopeningQueryKey,
} from "./keys";
import {
  getJobopeningCareers,
  getJobopeningCareersAvailable,
  getJobopeningDescription,
  getPublicJobopening,
} from "./requests";

/**
 * Returns a jobopening by the provided slug.
 */
export function getPublicJobopeningQueryOptions(
  httpClient: HttpClientInstance,
  slug: string,
  enabled?: boolean,
) {
  return createQueryOptions({
    queryKey: getPublicJobopeningQueryKey(slug),
    queryFn: ({ signal }) => getPublicJobopening(httpClient, slug, signal),
    enabled,
  });
}
/**
 * Returns a jobopening by the provided slug.
 */
export function useGetPublicJobopening(slug: string, enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(getPublicJobopeningQueryOptions(httpClient, slug, enabled));
}

/**
 * List job openings added to careers page.
 */
export function getJobopeningCareersQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  enabled?: boolean,
) {
  return createQueryOptions({
    queryKey: getJobopeningCareersQueryKey(workspaceId),
    queryFn: ({ signal }) =>
      getJobopeningCareers(httpClient, workspaceId, signal),
    enabled,
  });
}
/**
 * List job openings added to careers page.
 */
export function useGetJobopeningCareers(
  workspaceId: number,
  enabled?: boolean,
) {
  const httpClient = useHttpClient();
  return useQuery(
    getJobopeningCareersQueryOptions(httpClient, workspaceId, enabled),
  );
}

/**
 * List job openings available to be added to careers page.
 */
export function getJobopeningCareersAvailableQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  enabled?: boolean,
) {
  return createQueryOptions({
    queryKey: getJobopeningCareersAvailableQueryKey(workspaceId),
    queryFn: ({ signal }) =>
      getJobopeningCareersAvailable(httpClient, workspaceId, signal),
    enabled,
  });
}
/**
 * List job openings available to be added to careers page.
 */
export function useGetJobopeningCareersAvailable(
  workspaceId: number,
  enabled?: boolean,
) {
  const httpClient = useHttpClient();
  return useQuery(
    getJobopeningCareersAvailableQueryOptions(httpClient, workspaceId, enabled),
  );
}

/**
 * Get job opening description
 */
export function getJobopeningDescriptionQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  enabled?: boolean,
) {
  return createQueryOptions({
    queryKey: getJobopeningDescriptionQueryKey(workspaceId, openingId),
    queryFn: ({ signal }) =>
      getJobopeningDescription(httpClient, workspaceId, openingId, signal),
    enabled,
  });
}
/**
 * Get job opening description
 */
export function useGetJobopeningDescription(
  workspaceId: number,
  openingId: number,
  enabled?: boolean,
) {
  const httpClient = useHttpClient();
  return useQuery(
    getJobopeningDescriptionQueryOptions(
      httpClient,
      workspaceId,
      openingId,
      enabled,
    ),
  );
}
